export interface IModData {
  modid: string;
  active: boolean;
  installed: boolean;
  allowReorder: boolean;
}

export interface IActivatedMod {
  url: string;
  mods: any;
}

export enum Direction {
  Up,
  Down
}
